import React, { Component } from "react";
import { Row, Col } from "react-bootstrap";
import Select2 from "../../../../../../components/common/select/Select2";
import Input from "../../../../../../components/common/input/Input";
import { Field } from "redux-form";
import { required } from "../../../../../../utils/forms/validators";
// import styles from './FilterBox.scss';

const CATEGORIES = [
  { id: "professional_summary", value: "Personal Bio" },
  { id: "work_history", value: "Work History" }
];

class FilterBox extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedCategory: -1
    };
    this.onChange = this.onChange.bind(this);
  }

  componentDidMount() {
    if (this.props.selected !== this.state.selectedCategory) {
      this.setState({ selectedCategory: this.props.selected });
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.selected !== this.state.selectedCategory) {
      this.setState({ selectedCategory: nextProps.selected });
    }
  }

  onChange(value) {
    this.setState({ selectedCategory: value });
  }

  renderKeyword() {
    return (
      <Field
        name={`${this.props.inputName}.keyword`}
        placeholder="Keyword"
        component={Input}
      />
    );
  }

  render() {
    return (
      <Row>
        <Col xs={12} md={5}>
          <Field
            validate={required}
            name={this.props.name}
            type="select"
            placeholder="Database Field"
            component={Select2}
            options={CATEGORIES}
            onSelectChange={this.onChange}
          />
        </Col>
        <Col xs={12} md={7}>
          {this.renderKeyword()}
        </Col>
      </Row>
    );
  }
}

export default FilterBox;



// WEBPACK FOOTER //
// ./src/routes/admin/project/potentialMatches/components/advancedSearch/FilterBox.js